import { render, staticRenderFns } from "./EventFooterText.vue?vue&type=template&id=5349569e"
import script from "./EventFooterText.vue?vue&type=script&lang=js"
export * from "./EventFooterText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports